import React from 'react';

const VARIANT_BY_LABEL = {
  ALFA:  'alfa',
  BETA:  'beta',
  WIP:   'wip',
  MVP:   'mvp',
  V1:    'v1',
  S1:    's1',
  AI:    'ai',
  DEV:   'dev',
  NY:    'ny',
};

export function NavItemBadge({ label, variant }) {
  if (!label) return null;
  const v = variant || VARIANT_BY_LABEL[String(label).toUpperCase()] || 'count';
  return <span className={`kp-nav-badge kp-nav-badge--${v}`}>{label}</span>;
}
